<div
  class="nnki-rounded-background-image cursor-pointer w-full mb-4 relative shadow-[-5px_2px_10px_0] shadow-gray-twenty"
  [style.background-image]="
    challengeScore ? sanitizerService.imageProfile(challengeScore.student.picture) : ''
  "
  (click)="modalService.openModalStudentProfile(challengeScore?.student.id)"
>
  <div
    class="absolute bottom-0 -left-2 h-[24px] min-w-[24px] rounded-xl text-15 font-extrabold px-3 flex-center text-white"
    [ngClass]="{ 'bg-black': black, 'bg-site-main-one': !black }"
    [class.-black]="black"
  >
    <svg-icon
      *ngIf="!black"
      src="assets/images/svg-icons/icon-medal.svg"
      [svgStyle]="{ 'width.px': '10' }"
      class="mr-2"
    ></svg-icon>
    {{ position ? position : '-' }}
  </div>
</div>

<ng-container *ngIf="challengeScore">
  <div
    class="text-center text-13 font-extrabold mb-2 truncate max-w-full cursor-pointer"
    [class.text-white]="black"
    (click)="modalService.openModalStudentProfile(challengeScore.student.id)"
  >
    {{ challengeScore.student.username }}
  </div>
  <div
    class="text-center text-10 font-semibold"
    *ngIf="challengeScore.score"
    [class.text-white]="black"
  >
    {{ challengeScore.score | number : '1.0-0' : 'fr' }}
    {{ 'examens.pts' | translate }}
  </div>
</ng-container>
